import { Head } from 'vite-react-ssg'

interface PageMetaProps {
  title: string
  description: string
  canonical: string
  ogTitle?: string
  ogImage?: string
  schema?: object
  /** When true, add noindex,nofollow so the page is not indexed by search engines */
  noindex?: boolean
}

export function PageMeta({ title, description, canonical, ogImage, schema, ogTitle, noindex }: PageMetaProps) {
  const fullTitle = `${title} | NextTech Consultants — Pacific Northwest MSP`
  const socialTitle = ogTitle || fullTitle
  const image = ogImage || 'https://nexttechconsultants.com/og-default.jpg'
  return (
    <Head>
      <title suppressHydrationWarning>{fullTitle}</title>
      <meta name="description" content={description} suppressHydrationWarning />
      {noindex && (
        <meta name="robots" content="noindex, nofollow" suppressHydrationWarning />
      )}
      <link rel="canonical" href={canonical} suppressHydrationWarning />
      <meta property="og:title" content={socialTitle} suppressHydrationWarning />
      <meta property="og:description" content={description} suppressHydrationWarning />
      <meta property="og:url" content={canonical} suppressHydrationWarning />
      <meta property="og:image" content={image} suppressHydrationWarning />
      <meta property="og:type" content="website" suppressHydrationWarning />
      <meta name="twitter:card" content="summary_large_image" suppressHydrationWarning />
      <meta name="twitter:title" content={socialTitle} suppressHydrationWarning />
      <meta name="twitter:description" content={description} suppressHydrationWarning />
      <meta name="twitter:image" content={image} suppressHydrationWarning />
      {schema && (
        <script type="application/ld+json" suppressHydrationWarning>
          {JSON.stringify(schema)}
        </script>
      )}
    </Head>
  )
}
